import { createReducer, on } from '@ngrx/store';
import {
  AddressInfo,
  OwnerCenterInfo,
  AthleteInfo,
  UserInfo
} from '@libs/entity-lib';
import * as fromActions from './profile.actions';

export interface State {
  addressInfo: AddressInfo | null;
  ownerCenterInfo: OwnerCenterInfo | null;
  athleteInfo: AthleteInfo | null;
  userInfo: UserInfo | null;
  loading: boolean;
  error?: any;
  isUserNameValid: boolean;
  isEmailValid: boolean;
}

export const initialState: State = {
  addressInfo: null,
  ownerCenterInfo: null,
  athleteInfo: null,
  userInfo: null,
  loading: false,
  error: null,
  isUserNameValid: false,
  isEmailValid: false
};

export const reducer = createReducer(
  initialState,
  on(fromActions.setInitAthleteState, (state, { newState }) => ({
    ...state,
    ...newState
  })),
  on(fromActions.setAddressInfo, (state, { addressInfo }) => ({
    ...state,
    addressInfo,
  })),
  on(fromActions.setOwnerInfo, (state, { ownerCenterInfo }) => ({
    ...state,
    ownerCenterInfo,
  })),
  on(fromActions.setAthleteInfo, (state, { athleteInfo }) => ({
    ...state,
    athleteInfo
  })),
  on(fromActions.registerProfile, (state, { profileState }) => ({
    ...state,
    newState: profileState,
  })),
  on(fromActions.registerProfileFailed, (state, { error }) => ({
    ...state,
    error
  })),
  on(fromActions.setLoading, (state, { loading }) => ({ ...state, loading })),
  on(fromActions.verifyEmailSuccefully, (state, { isEmailValid }) => ({
    ...state,
    isEmailValid
  })),
  on(fromActions.setUserInfo, (state, { userInfo }) => ({
    ...state,
    userInfo,
  })),
  on(fromActions.verifyUserNameSuccefully, (state, { isUserNameValid }) => ({
    ...state,
    isUserNameValid
  })),
  on(fromActions.verifyEmailSuccefully, (state, { isEmailValid }) => ({
    ...state,
    isEmailValid
  })),
  on(fromActions.resetStore, () => ({
    sportCenter: null,
    addressInfo: null,
    ownerCenterInfo: null,
    athleteInfo: null,
    userInfo: null,
    loading: false,
    error: null,
    isUserNameValid: false,
    isEmailValid: false
  }))
);
